import { Modal, Typography, List, ListItemText, ListItem, Link } from '@mui/material';
import { Box } from '@mui/system';
import { IQuestion } from '../types';

interface InfoModalProps {
    question: IQuestion | null;
    setQuestion: (q: IQuestion | null) => void;
}

export const InfoModal = (props: InfoModalProps) => {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: "100vh",
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        overflow: "scroll",
    };
    const months = ["Jan", "Feb", "Mar", "Apr", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "specimen"]

    return (
        <Modal
            open={props.question != null}
            onClose={() => props.setQuestion(null)}
            aria-labelledby="question info"
        >
            <Box sx={style}>
                <Typography id="question info" variant="h6" component="h2">
                    Info
                </Typography>
                {
                    props.question
                        ?
                        <List>
                            {/* <ListItem>
                                <ListItemText>
                                    board: {props.question.board}
                                </ListItemText>
                            </ListItem> */}
                            <ListItem>
                                <ListItemText>
                                    difficulty: {props.question.difficulty}
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    level: {props.question.level}
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    subject code: {props.question.subject_code}
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    topic: {props.question.topic}
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    sub topic: {props.question.sub_topic}
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    sub sub topic: {props.question.sub_sub_topic}
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    date: {months[props.question.month_index]} {props.question.year}
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    <Link href={props.question.ms_pdf_url} target="_blank">
                                        mark scheme
                                    </Link>
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    <Link href={props.question.qp_pdf_url} target="_blank">
                                        question
                                    </Link>
                                </ListItemText>
                            </ListItem>
                        </List>
                        :
                        <></>
                }
            </Box>
        </Modal>
    )

}